import { FormsHelper } from "@/Common/Helpers/MyleFormsHelper";
import { ElementType, FormAttribute, FormSection, IHasAttributes, IHasElementType, TemplateType } from "./FormTemplateInterfaces";

class FormTemplate implements IHasAttributes, IHasElementType {
    public Id: number;
    public Context: string;
    public InternalName: string;
    public DateCreated: Date;
    public Version: string;
    public TemplateType: TemplateType;
    public Sections: FormSection[];
    public Attributes: FormAttribute[];
    public ElementType: ElementType;

    public constructor(fields?: Partial<FormTemplate>) {
        Object.assign(this, fields);
        this.Sections = fields?.Sections?.map(x => new FormSection(x)) || [];
    }

    public getComponentName(attributeName: string = null): string {
        return FormsHelper.getComponentName(this, attributeName);
    }
}

export { FormTemplate };
